
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import { Announcement, ANNOUNCEMENT_TYPE } from '@run-diffusion/shared';
import AppOffersList from '@/views/Sessions/AppOffersList/AppOffersList.vue';
import JoinOurDiscord from '@/components/JoinOurDiscord/JoinOurDiscord.vue';
import RotatingBannerSystem from '@/components/PromoBanners/RotatingBannerSystem.vue';
import { ROUTER } from '@/router/constants';
import { getPlatformHomePreference, PlatformHomePreference, setPlatformHomePreference } from '@/utils';

export default Vue.extend({
	name: 'Sessions',
	metaInfo: {
		title: 'Sessions | RunDiffusion',
	},
	data () {
		return {
			selectedStorage: null,
			dismissedNoNewSessionsAnnouncements: false,
			showAllBanners: false, // Production ready - banners show based on conditions
		};
	},
	computed: {
		...mapState([
			'upsellDialog',
			'user',
			'team',
			'announcements',
			'stableDiffusionModel',
			'appQueryParamsData',
		]),
		noNewSessionsAnnouncements () {
			return this.announcements.filter((announcement: Announcement) => (
				announcement.type === ANNOUNCEMENT_TYPE.NO_NEW_SESSIONS
			));
		},
	},
	mounted () {
		this.initCreatorsClubDialog();

		const platformHomePreference: PlatformHomePreference = getPlatformHomePreference();
		// If preference is unset or RUNNIT, go to Runnit home
		if (!platformHomePreference || platformHomePreference === 'RUNNIT') {
			setPlatformHomePreference('RUNNIT');
			this.routerReplace(this.$route, this.$router, { name: ROUTER.RUNNITS_HOME });
		}
	},
	methods: {
		...mapActions([
			'updateAppQueryParamsData',
			'setUpsellDialog',
		]),
		initCreatorsClubDialog () {
			if (!this.upsellDialog.creatorsClub && this.user && this.appQueryParamsData && this.appQueryParamsData.creatorsClubSignUp) {
				// Pop Creator's Club promotional dialog
				this.setUpsellDialog({ creatorsClub: true });
				// Reset creatorsClubSignUp to false
				this.updateAppQueryParamsData({ creatorsClubSignUp: false });
			}
		},
	},
	components: {
		JoinOurDiscord,
		AppOffersList,
		RotatingBannerSystem,
	},
});
